import React from "react";
import { Helmet } from "react-helmet";
import axios from 'axios';
import _chunk from 'lodash/chunk';
import './style.css';
import TabContainer from "react-bootstrap/TabContainer";
import TabContent from "react-bootstrap/TabContent";
import TabPane from "react-bootstrap/TabPane";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Pagination from 'react-paginating';
import Footer from '../../components/Footer/Footer'
import  { site_Search_API, HeaderConfig, user_access_level, apiUrl } from 'Api/Api';
import { origin } from 'utils/Helper';
import SearchResults from '../../components/SearchResults/SearchResults'
import FullPageSpinner from '../../components/FullPageSpinner/FullPageSpinner'
import { getQueryString } from "utils/Helper";
import { local_routes } from 'utils/Routes';
import presentationPh from 'Assets/presentation.svg';
import eventsPH from 'Assets/event-img.jpg';
import peoplePH from 'Assets/avatarnew.svg';
import channelPH from 'Assets/channel.svg';
import noImage from 'Assets/noimage.png';

import UserContext from 'store/UserContext';

class searchResults extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            searchText: '',
            isLoader: false,
            searchData: {},
            selectedChunkCount: 0,
            selectedResults: '',
            isNoResults: false,
            catCount: null,
            //catName: 'presentations',
            catName: '',
            org_friendly_url: ""
        };
        const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        this.org_friendly_url = "";
        if (org_friendly_url) {
          this.state.org_friendly_url = org_friendly_url;
          this.org_friendly_url = org_friendly_url;
        }

    }

    componentDidMount() {
        const query = decodeURIComponent(getQueryString('searchQuery') || 'art');
        console.log("searchResults componentDidMount",query);
        this.getSearchResult(query);
        this.setState({
            searchText: query
        });
    }
    
    componentWillReceiveProps() {
        const query = decodeURIComponent(getQueryString('searchQuery'));
        //console.log("searchResults componentWillReceiveProps",query);
        if (this.state.searchText !== query) {
            this.setState({
                //catName: 'presentations',
                searchText: query
            }, () => {
                this.getSearchResult(query);
            });
        }
    }
    
    paginationAlg = (length, currentPage, itemsPerPage) => {
        const to = (currentPage * itemsPerPage) > length ? length : currentPage * itemsPerPage
        return {
            total: length,
            per_page: itemsPerPage,
            current_page: currentPage,
            last_page: Math.ceil(length / itemsPerPage),
            from: ((currentPage - 1) * itemsPerPage) + 1,
            to,
        };
    };

    handlePageChange = page => {
        const { catCount } = this.state;
        const { from, to, total } = this.paginationAlg(catCount, page, 30)

        const selectedResults = `${from} - ${to} of ${total} results`;
        this.setState({
            currentPage: page,
            selectedResults,
        });
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    onSearchChange = ({target}) => {
        this.setState({searchText: target.value})
    }
    onSearchPress = ({ key = '' }) => {
        const { searchText } = this.state;
        if(key === 'Enter' && searchText){
            this.setState({
                //catName: 'presentations'
            }, () => {
                this.getSearchResult(searchText)
            });
        }
    }

    getSearchResult(searchText) {
        this.setState({isLoader: true, isNoResults: false});
        let params = {
          q: searchText,
          limit: 200
        }
        //axios.get(`${site_Search_API}?q=${encodeURIComponent(searchText)}&limit=200`, HeaderConfig)
        axios.get(`${site_Search_API}`, { params, ...HeaderConfig })
            .then(response => {
                const search_query_results = response.data && response.data.search_query_results ? response.data.search_query_results : [];
                if (search_query_results.length) {
                    let first_catName;
                    const events = [],
                        presentations = [],
                        users = [],
                        channels = [],
                        categories = [],
                        locations= [];
                        
                    const entity_info = search_query_results.map((data) => data.entity_info);
                    
                    entity_info.forEach(({
                        entity_type,
                        entity_name,
                        description,
                        image_url,
                        friendly_url,
                        entity_uuid,
                        poster_image_url,
                        spotlight_image_url,
                        avatar_image_url,
                        logo_image_url,
                        city_skyline_wide_image_url,
                        city_skyline_image_url,
                        spotlighted_image_url,
                    }) => {
                        if (!friendly_url) {
                            return;
                        }
                        if (!first_catName) {
                            first_catName = entity_type;
                        }
                        if (entity_type === 'presentations') {
                            presentations.push({
                                friendly_url:friendly_url,
                                entity_uuid:entity_uuid,
                                entity_type:entity_type,
                                heading: entity_name,
                                pk_content: description,
                                img: image_url
                            });
                        } else if (entity_type === 'events') {
                            events.push({
                                friendly_url:friendly_url,
                                entity_uuid:entity_uuid,
                                entity_type:entity_type,
                                heading: entity_name,
                                pk_content: description,
                                img: poster_image_url || spotlight_image_url,
                            });
                        } else if (entity_type === 'users') {
                            users.push({
                                friendly_url:friendly_url,
                                entity_uuid:entity_uuid,
                                entity_type:entity_type,
                                heading: entity_name,
                                pk_content: description,
                                img: avatar_image_url,
                            });
                        } else if (entity_type === 'channels') {
                            channels.push({
                                friendly_url:friendly_url,
                                entity_uuid:entity_uuid,
                                entity_type:entity_type,
                                heading: entity_name,
                                pk_content: description,
                                img: logo_image_url
                            });
                        } else if (entity_type === 'categories') {
                            categories.push({
                                friendly_url:friendly_url,
                                entity_uuid:entity_uuid,
                                entity_type:entity_type,
                                heading: entity_name,
                                pk_content: description,
                                img: image_url
                            });
                        } else if (entity_type === 'locations') {
                            locations.push({
                                friendly_url:friendly_url,
                                entity_uuid:entity_uuid,
                                entity_type:entity_type,
                                heading: entity_name,
                                pk_content: description,
                                img: city_skyline_wide_image_url || city_skyline_image_url || spotlighted_image_url
                            });
                        }
                    });
                    const searchData = {
                        presentations: _chunk(presentations, 30),
                        events: _chunk(events, 30),
                        users: _chunk(users, 30),
                        categories: _chunk(categories, 30),
                        channels: _chunk(channels, 30),
                        locations: _chunk(locations, 30),
                        presentationsCount: presentations.length,
                        eventsCount: events.length,
                        usersCount: users.length,
                        categoriesCount: categories.length,
                        channelsCount: channels.length,
                        locationsCount: locations.length,
                    };

                    //const { from, to, total } = this.paginationAlg(searchData[`${this.state.catName}Count`], 1, 30);
                    const { from, to, total } = this.paginationAlg(searchData[`${first_catName}Count`], 1, 30);
                    
                    //console.log("getSearchResult",first_catName);
                    
                    this.setState({
                        catName: first_catName,
                        searchData,
                        isLoader: false,
                        //selectedChunkCount: searchData[`${this.state.catName}`].length,
                        selectedChunkCount: searchData[`${first_catName}`].length,
                        selectedResults: `${from} - ${to} of ${total} results`,
                        //catCount: searchData[`${this.state.catName}Count`],
                        catCount: searchData[`${first_catName}Count`],
                    });
                } else {
                    this.setState({
                        searchData: {},
                        isLoader: false,
                        currentPage: 1,
                        selectedResults: '',
                        isNoResults: true,
                    });
                }
            }).catch(() => {
                this.setState({
                    searchData: {},
                    isLoader: false,
                    currentPage: 1,
                    selectedResults: '',
                    isNoResults: true,
                });
            });
    }

    onNavClick = (catName, catCount) => {
        const {searchData} = this.state;
        const { from, to, total } = this.paginationAlg(catCount, 1, 30)

        if (searchData[catName]) {
            this.setState({
                selectedChunkCount: searchData[catName].length,
                selectedResults: `${from} - ${to} of ${total} results`,
                currentPage: 1,
                catCount,
                catName,
            });
        }
    }

    // presentations Data
    presentationsData = (item) => {
        let modImg;
        //console.log("SearchResults presentationsData org_friendly_url 1",this.state.org_friendly_url);
        //console.log("SearchResults presentationsData org_friendly_url 2",this.org_friendly_url);
        if (item.img !== undefined) {
            let url = item.img;
            let array = url.split("/");
            modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_640x480/${array[5]}`
        } else  modImg = presentationPh;
        return (
            <div key={item.entity_uuid}>
                <SearchResults
                    key={item.id}
                    heading={item.heading}
                    img={modImg}
                    pk_content={item.pk_content}
                    url={`${origin}${local_routes.presentations}/${item.friendly_url}`}
                    entity_type={item.entity_type}
                    friendly_url={item.friendly_url}
                    entity_uuid={item.entity_uuid}
                    nav_link={`${local_routes.presentations}/${item.friendly_url}`}
                    org_friendly_url={this.state.org_friendly_url}
                />
            </div>
        );
    }

    // events Data
    eventsData = (item) => {
        let modImg;
        if (item.img !== undefined) {
            let url = item.img;
            let array = url.split("/");
            modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_200x200/${array[5]}`
        } else  modImg = eventsPH;
        return (
            <div key={item.entity_uuid}>
                <SearchResults
                    key={item.id}
                    heading={item.heading}
                    img={modImg}
                    pk_content={item.pk_content}
                    url={`${origin}${local_routes.events}/${item.friendly_url}`}
                    entity_type={item.entity_type}
                    friendly_url={item.friendly_url}
                    entity_uuid={item.entity_uuid}
                    nav_link={`${local_routes.events}/${item.friendly_url}`}
                    org_friendly_url={this.state.org_friendly_url}
                />
            </div>
        );
    }

    inactivateEntity = async (item,index,pageIndex) => {
      console.log("INACTIVATE",item,index);

      // remove from screen right away
      if (item.entity_type === 'users') {
        let tmp_users = [ ...this.state.searchData.users ];
        if (tmp_users[pageIndex] && tmp_users[pageIndex][index]) {
          //console.log("HMM1",tmp_users[0]);
          tmp_users[pageIndex].splice(index, 1);
          //console.log("HMM2",tmp_users[0]);
          this.setState({
            searchData: {
              ...this.state.searchData,
              users: tmp_users
            }
          });
        }
      }

      let patch_obj = {
        status_code: 2
      };
      
      try {
        await axios.patch(`${apiUrl}${item.entity_type}/${item.entity_uuid}`,patch_obj);
      } catch (err) {
        // probably faulty elasticsearch data...get proper entity_uuid by GET friendly_url
        console.error("Could not find entity via entity_uuid - trying to get proper entity_uuid via friendly_url");
        let proper_entity_response = await axios.get(`${apiUrl}${item.entity_type}/${item.friendly_url}`);
        if (proper_entity_response.data.entity_uuid) {
          await axios.patch(`${apiUrl}${item.entity_type}/${proper_entity_response.data.entity_uuid}`,patch_obj);
        }
      }
      
    }

    // people Data
    peopleData = (item,index,pageIndex) => {
        let modImg;
        if (item.img !== undefined) {
            let url = item.img;
            let array = url.split("/");
            //modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_640x360/${array[5]}`
            modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_200x200/${array[5]}`
        } else modImg = peoplePH;
        
        return (
            <div key={item.entity_uuid}>
                { user_access_level === 'admin' &&
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => this.inactivateEntity(item,index,pageIndex)}
                  >
                    Inactivate
                  </Button>
                }
                <SearchResults
                    key={item.id}
                    heading={item.heading}
                    img={modImg}
                    pk_content={item.pk_content}
                    url={`${origin}${local_routes.users}/${item.friendly_url}`}
                    entity_type={item.entity_type}
                    friendly_url={item.friendly_url}
                    entity_uuid={item.entity_uuid}
                    nav_link={`${local_routes.users}/${item.friendly_url}`}
                    org_friendly_url={this.state.org_friendly_url}
                />
            </div>
        );
    }

    // channels Data
    channelsData = (item) => {
        let modImg;
        if (item.img !== undefined) {
            let url = item.img;
            let array = url.split("/");
            modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_200x200/${array[5]}`
        } else modImg = channelPH;
        return (
            <div key={item.entity_uuid}>
                <SearchResults
                    key={item.id}
                    heading={item.heading}
                    img={modImg}
                    pk_content={item.pk_content}
                    url={`${origin}${local_routes.channels}/${item.friendly_url}`}
                    entity_type={item.entity_type}
                    friendly_url={item.friendly_url}
                    entity_uuid={item.entity_uuid}
                    nav_link={`${local_routes.channels}/${item.friendly_url}`}
                    org_friendly_url={this.state.org_friendly_url}
                />
            </div>
        );
    }

    // categories Data
    categoriesData = (item) => {
        let modImg;
        if (item.img !== undefined) {
            let url = item.img;
            let array = url.split("/");
            modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_200x200/${array[5]}`
        } else modImg = noImage;
        return (
            <div key={item.entity_uuid}>
                <SearchResults
                    key={item.id}
                    heading={item.heading}
                    headingStatus={false}
                    img={item.img !== undefined ? modImg : noImage}
                    imgStatus={false}
                    pk_content={item.pk_content}
                    pk_content_status={false}
                    url={`${origin}${local_routes.categories}/${item.friendly_url}`}
                    entity_type={item.entity_type}
                    friendly_url={item.friendly_url}
                    entity_uuid={item.entity_uuid}
                    nav_link={`${local_routes.categories}/${item.friendly_url}`}
                    org_friendly_url={this.state.org_friendly_url}
                />
            </div>
        );
    }

    // cities Data
    citiesData = (item) => {
        let modImg;
        if (item.img !== undefined) {
            let url = item.img;
            let array = url.split("/");
            modImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_noborder_200x200/${array[5]}`
        } else modImg = noImage;
        return (
            <div key={item.entity_uuid}>
                <SearchResults
                    key={item.id}
                    heading={item.heading}
                    headingStatus={false}
                    img={item.img !== undefined ? modImg : noImage}
                    imgStatus={false}
                    pk_content={item.pk_content}
                    pk_content_status={false}
                    url={`${origin}${local_routes.cities}/${item.friendly_url}`}
                    entity_type={item.entity_type}
                    friendly_url={item.friendly_url}
                    entity_uuid={item.entity_uuid}
                    nav_link={`${local_routes.cities}/${item.friendly_url}`}
                    org_friendly_url={this.state.org_friendly_url}
                />
            </div>
        );
    }

    setKey = catName => {
        this.setState({
            catName
        });
    }

    // People,channels, categories,cities
    render() {
        const { currentPage, searchData, isLoader, selectedChunkCount, selectedResults, isNoResults, searchText, catName } = this.state;
        const {
            presentations = [],
            categories = [],
            channels = [],
            events = [],
            locations = [],
            users = [],
            presentationsCount,
            eventsCount,
            usersCount,
            categoriesCount,
            channelsCount,
            locationsCount,
        } = searchData;
        
        return (
            <React.Fragment>
            <Helmet defer={false}>
                <title>PechaKucha Search Results</title>
            </Helmet>
            {isLoader && <FullPageSpinner />}
            <div className="container">
                <div className="search-results">
                    <TabContainer
                        id="left-tabs-example"
                        activeKey={catName}
                        onSelect={this.setKey}
                        //defaultActiveKey={catName}
                    >
                        <Row>
                            <Col lg={3}>
                                <Nav variant="pills" className="flex-column">
                                    <Nav.Item className={presentationsCount === 0 ? 'disableNav' : null}>
                                        <Nav.Link eventKey="presentations" onSelect={() => this.onNavClick("presentations", presentationsCount)}>Presentations</Nav.Link>
                                        <span>{presentationsCount || null }</span>
                                    </Nav.Item>
                                    <Nav.Item className={eventsCount === 0 ? 'disableNav' : null}>
                                        <Nav.Link eventKey="events" onSelect={() => this.onNavClick("events", eventsCount)}>Events</Nav.Link>
                                        <span>{eventsCount || null}</span>
                                    </Nav.Item>
                                    <Nav.Item className={usersCount === 0 ? 'disableNav' : null}>
                                        <Nav.Link eventKey="users" onSelect={() => this.onNavClick("users", usersCount)}>People</Nav.Link>
                                        <span>{usersCount || null}</span>
                                    </Nav.Item>
                                    <Nav.Item className={categoriesCount === 0 ? 'disableNav' : null}>
                                        <Nav.Link eventKey="categories" onSelect={() => this.onNavClick("categories", categoriesCount)}>Categories</Nav.Link>
                                        <span>{categoriesCount || null}</span>
                                    </Nav.Item>
                                    <Nav.Item className={channelsCount === 0 ? 'disableNav' : null}>
                                        <Nav.Link eventKey="channels" onSelect={() => this.onNavClick("channels", channelsCount)}>Channels</Nav.Link>
                                        <span>{channelsCount || null}</span>
                                    </Nav.Item>
                                    <Nav.Item className={locationsCount === 0 ? 'disableNav' : null}>
                                        <Nav.Link eventKey="locations" onSelect={() => this.onNavClick("locations", locationsCount)}>Cities</Nav.Link>
                                        <span>{locationsCount || null}</span>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col lg={9}>
                                <div className="search">
                                    <div className="search-nav">
                                        <h4>Search results for '{searchText}'</h4>
                                        {/*
                                        <i className="fa fa-search nav-search"></i>
                                        <input type="text" autoFocus value={searchText} id="search" onChange={this.onSearchChange} onKeyPress={this.onSearchPress} placeholder="Search PechaKucha..." />
                                        */}
                                    </div>
                                    {
                                        isNoResults ? <div className="pks-data"><h3>No results found...</h3></div> : 
                                        !isLoader ?
                                        <React.Fragment>
                                            <TabContent>
                                                <TabPane eventKey="presentations">
                                                    <div className="pks-data">
                                                        <h3>Presentations</h3>
                                                        <p>{selectedResults}</p>
                                                    </div>
                                                    {
                                                        presentations.length && presentations[currentPage - 1] ? 
                                                        presentations[currentPage - 1].map((item) =>
                                                        this.presentationsData(item) 
                                                        ) : null
                                                    
                                                    }

                                                </TabPane>
                                                <TabPane eventKey="events">
                                                    <div className="pks-data">
                                                        <h3>Events</h3>
                                                        <p>{selectedResults}</p>
                                                    </div>
                                                    {
                                                        events.length && events[currentPage - 1] ? 
                                                        events[currentPage - 1].map((item) =>
                                                        this.eventsData(item)
                                                        ) : null
                                                    }
                                                </TabPane>
                                                <TabPane eventKey="users">
                                                    <div className="pks-data">
                                                        <h3>People</h3>
                                                        <p>{selectedResults}</p>
                                                    </div>
                                                    {
                                                        users.length && users[currentPage - 1] ? 
                                                        users[currentPage - 1].map((item,index) =>
                                                         this.peopleData(item,index,(currentPage - 1))
                                                        ) : null
                                                    }
                                                </TabPane>
                                                <TabPane eventKey="categories">
                                                    <div className="pks-data">
                                                        <h3>Categories</h3>
                                                        <p>{selectedResults}</p>
                                                    </div>
                                                    {
                                                        categories.length && categories[currentPage - 1] ? categories[currentPage - 1].map((item) =>
                                                            this.categoriesData(item)
                                                        ) : null
                                                    }
                                                </TabPane>
                                                <TabPane eventKey="channels">
                                                    <div className="pks-data">
                                                        <h3>Channel</h3>
                                                        <p>{selectedResults}</p>
                                                    </div>
                                                    {
                                                        channels.length && channels[currentPage - 1] ? channels[currentPage - 1].map((item) =>
                                                            this.channelsData(item)
                                                        ) : null
                                                    }
                                                </TabPane>
                                                <TabPane eventKey="locations">
                                                    <div className="pks-data">
                                                        <h3>Cities</h3>
                                                        <p>{selectedResults}</p>
                                                    </div>
                                                    {
                                                        locations.length && locations[currentPage - 1] ? 
                                                        locations[currentPage - 1].map((item) =>
                                                            this.citiesData(item)
                                                        ) : null
                                                    }
                                                </TabPane>
                                            </TabContent>
                                        <div>
                                            <Pagination
                                                //className={this.context.theme}
                                                total={selectedChunkCount * 2}
                                                limit={2}
                                                pageCount={10}
                                                currentPage={currentPage}
                                            >
                                                {({
                                                    pages,
                                                    currentPage,
                                                    hasNextPage,
                                                    hasPreviousPage,
                                                    previousPage,
                                                    nextPage,
                                                    getPageItemProps    
                                                }) => (
                                                        <div className="pagerButtons">
                                                            {hasPreviousPage && (
                                                                <button className="btn-none"
                                                                    {...getPageItemProps({
                                                                        pageValue: previousPage,
                                                                        onPageChange: this.handlePageChange
                                                                    })}
                                                                >
                                                                    {"Previous"}
                                                                </button>
                                                            )}

                                                            {pages.map(page => {
                                                                let activePage = null;
                                                                if (currentPage === page) {
                                                                    activePage = { color:"rgb(248, 69, 69)" };
                                                                }
                                                                return (
                                                                    <button
                                                                        {...getPageItemProps({
                                                                            pageValue: page,
                                                                            key: page,
                                                                            style: activePage,
                                                                            onPageChange: this.handlePageChange
                                                                        })}
                                                                        className={!hasNextPage ? 'disableBtn' : ''}
                                                                    >
                                                                        {page}
                                                                    </button>
                                                                );
                                                            })}
                                                            {hasNextPage && (
                                                                <button
                                                                    {...getPageItemProps({
                                                                        pageValue: nextPage,
                                                                        onPageChange: this.handlePageChange
                                                                    })}
                                                                >
                                                                    {"Next"}
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                            </Pagination>
                                            </div>
                                        </React.Fragment> : null
                                    }
                                </div>
                            </Col>
                        </Row>
                    </TabContainer>
                </div>
                
            </div>
            <Footer />
            </React.Fragment>
        );
    }
}
export default searchResults;